import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-dispute-already-submitted',
    templateUrl: './dispute-already-submitted.component.html',
    styleUrls: ['./dispute-already-submitted.component.scss'],
    standalone: false
})
export class DisputeAlreadySubmittedComponent implements OnInit {

  message: string;
  submit: string;

  constructor(private readonly route: ActivatedRoute) {
  }

  ngOnInit() {

    this.submit = this.route.snapshot.paramMap.get('message');
    sessionStorage.clear();
    localStorage.clear();

    if (this.submit === 'submit') {
      this.message = 'Dispute form has been successfully submitted!';
    } else {
      this.message = 'Dispute already submitted!';
    }
  }
}
